// general imports
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Vuelidate from 'vuelidate'
import VueLazyload from 'vue-lazyload'
import VModal from 'vue-js-modal/dist/index.nocss.js'
import 'vue-js-modal/dist/styles.css'
import panZoom from 'vue-panzoom'
import VueCookie from 'vue-cookie'
import i18n from './translations/i18n'
import Vue2TouchEvents from 'vue2-touch-events'
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

// fontawesome imports
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlusCircle, faChevronDown, faChevronRight, faQuestionCircle, faCheckCircle, faChair, faCircle, faExclamationTriangle, faShoppingCart, faUserCircle, faChevronLeft, faTimes, faBug, faLongArrowAltRight, faPlusSquare, faMinusSquare, faArrowsAlt, faSearchPlus, faSearchMinus, faDownload } from '@fortawesome/free-solid-svg-icons'
import { faMinusCircle, faTicketAlt } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import "@/sass/global-styles.scss";

// add fontawesome solid icons
library.add(
  faChevronDown,
  faChevronRight,
  faPlusCircle,
  faChair,
  faPlusSquare,
  faMinusCircle,
  faMinusSquare,
  faQuestionCircle,
  faCheckCircle,
  faCircle,
  faExclamationTriangle,
  faShoppingCart,
  faUserCircle,
  faChevronLeft,
  faTimes,
  faBug,
  faTicketAlt,
  faLongArrowAltRight,
  faArrowsAlt,
  faSearchPlus,
  faSearchMinus,
  faDownload
);


Vue.component('font-awesome-icon', FontAwesomeIcon)
// end of fontawesome //

Vue.use(Vuelidate)
Vue.use(VModal);
Vue.use(VueLazyload)
Vue.use(VueCookie);
Vue.use(panZoom);
Vue.use(Vue2TouchEvents)

Vue.config.productionTip = false;

Sentry.init({
  Vue,
  dsn: "https://c6e9b904f2e64df58e8e579a1e8ce33d@o269656.ingest.sentry.io/5862064",
  integrations: [new Integrations.BrowserTracing()],
  release: "wk-purchase-path@1.0.1",
  environment: process.env.SENTRY_ENVIRONMENT,

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: process.env.SENTRY_PERFORMANCE_SAMPLE_RATE,
});


import store from "@/store"

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount("#app");
